(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

$("document").ready(function(){
/* MOBILE MENU - show/hide */
 $(".js--toggle-mobile-navigation").on('click',function(e){
    $('body').toggleClass('overflow-hidden lg:overflow-auto');
    if(  $('.mobile-navigation > .menu').hasClass('-translate-x-full')){
       $('.mobile-navigation > .menu').removeClass('-translate-x-full pointer-events-none').addClass('pointer-events-auto');
    }else{
       $('.mobile-navigation > .menu').addClass('-translate-x-full pointer-events-none').removeClass('pointer-events-auto');
    }
 })

 /* MOBILE MENU - submenu expand/colapse*/
 $(".js--menu-links > .has-children > a").on("click",function(e){
    e.preventDefault();

    $(this).parent().siblings().find('ul').removeClass('py-2').addClass('h-0');
    $(this).next('ul').toggleClass('h-0 py-2');
 })

 /* MOBILE MENU - submenu tabs */
 $(".nav-tabs-widget-root .js--tab").on("click",function(e){
  e.preventDefault();

  $(this).closest('.nav-tabs-widget-root').find('.js--tab').addClass('bg-indigo-light').removeClass('bg-green text-white shadow-md');
  $(this).addClass("bg-green text-white shadow-md").removeClass('bg-indigo-light');

  var target = $(this).attr("data-target-tabpanel");
  $(this).closest('.nav-tabs-widget-root').find('.js--tabpanel').addClass('hidden');
  $('.'+target).removeClass('hidden');

 })


  /* MAIN MENU - search input */
  //$(".js--header-menu-search ").on('focus',function(){
  //  $(this).closest("form").find("button[type='submit']").addClass("text-blue-light");
  //})
  //$(".js--header-menu-search ").on('blur',function(){
  //  $(this).closest("form").find("button[type='submit']").removeClass("text-blue-light");
  //})


  /*Segmentify atck event to search button*/

  //$('[data-predictive-search-open-drawer]').on("click", function(e){
  //  e.preventDefault();
  //  console.log();
  //  triggerFocus(document.querySelector('[data-predictive-search-drawer-input]'));
//
  //});

})

function triggerFocus(element) {

  var eventType = "onfocusin" in element ? "focusin" : "focus",
      bubbles = "onfocusin" in element,
      event;

  if ("createEvent" in document) {
      event = document.createEvent("Event");
      event.initEvent(eventType, bubbles, true);
  }
  else if ("Event" in window) {
      event = new Event(eventType, { bubbles: bubbles, cancelable: true });
  }

  element.focus();
  element.dispatchEvent(event);
}

/*Show/hide top header block*/

window.HeaderHandleSticky = (function () {

  var variants = {
    hide: 'top-header',
    show: 'top-0',
  };


  function HandleSticky(container) {

    this.container = container;
    this.prevScroll = window.scrollY || document.documentElement.scrollTop;
    this.curScroll;
    this.direction = 0;
    this.prevDirection  = 0;
    this._setupListeners();
  }

  HandleSticky.prototype = Object.assign({}, HandleSticky.prototype, {

    _setupListeners: function () {
      this.eventHandlers = this._setupEventHandlers();
       window.addEventListener(
        'scroll',window.theme.Helpers.throttle(
          function() {
            this.eventHandlers._handleCheckScroll();
          }.bind(this),
          500
        )
      );
    },

    _setupEventHandlers: function () {
      return {
        _handleCheckScroll: this.checkScroll.bind(this),
      };
    },

    checkScroll:function() {

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      this.curScroll = window.scrollY || document.documentElement.scrollTop;
      if (this.curScroll > this.prevScroll) {
        //scrolled up
        this.direction = 2;
      }
      else if (this.curScroll < this.prevScroll) {
        //scrolled down
        this.direction = 1;
      }

      if (this.direction !== this.prevDirection) {
        this.toggleHeader(this.direction, this.curScroll);
      }

      this.prevScroll = this.curScroll;
    },

    toggleHeader: function(direction, curScroll) {
      if (direction === 2 && curScroll > 92) {

        //replace 52 with the height of your header in px

        this.container.classList.add(variants.hide);
        this.container.classList.remove(variants.show);
        this.prevDirection = direction;

      } else if (direction === 1) {
        this.container.classList.remove(variants.hide);
        this.container.classList.add(variants.show);
        this.prevDirection = direction;
      }
    }

  })

  return HandleSticky;

})();

var headerHandleSticky = new window.HeaderHandleSticky(document.querySelector('.data-header-section-root'));




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-stii-de-ce-cumperi"]) return;
  try {
    

        window.addEventListener('DOMContentLoaded', () => {
            $('.play-media').magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });


            $('[data-expand-cta]').click(function () {
                var $this = $(this);
                var $root = $(this).closest('[data-expand-root]');
                var $head = $root.find('[data-expand-head]');
                var $body = $root.find('[data-expand-body]');
                $root.toggleClass('js--visible');

                // Check if $body is currently visible
                if ($body.is(':visible')) {
                    $('html, body').animate({
                        scrollTop: $head.offset().top - ($('#shopify-section-header').outerHeight() + 50),
                    }, 150, function () {
                        // This is the callback after scrolling is complete
                        $body.slideUp(800);
                    });

                } else {
                    $body.slideDown(800);
                }
            })
        });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-bundle-app"]) return;
  try {
    
window.ProductQuantitySection = (function () {
  var selectors = {
    quantity: '[data-quantity-input]',
    quantityDecrement: '[data-quantity-decrement]',
    quantityIncrement: '[data-quantity-increment]'
  }

  function ProductQuantitySection(container) {

    this.container = container;
    this.cache = {};
    this.eventHandlers = {};
    this._cacheSelectors();
    this._setupListeners();
  }

  ProductQuantitySection.prototype = Object.assign({}, ProductQuantitySection.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        quantity: this.container.querySelector(
          selectors.quantity
        ),
        quantityDecrement: this.container.querySelector(
          selectors.quantityDecrement
        ),
        quantityIncrement: this.container.querySelector(
          selectors.quantityIncrement
        ),
      }
    },

    _setupListeners: function() {
      this.eventHandlers = this._setupEventHandlers();

      this.cache.quantityDecrement.addEventListener(
        'click',
         this.eventHandlers.handleQuantityDecrement
      );

      this.cache.quantityIncrement.addEventListener(
        'click',
        this.eventHandlers.handleQuantityIncrement
      );
    },

    _setupEventHandlers:function(){
      return {
        handleQuantityDecrement: this._handleQuantityDecrement.bind(this),
        handleQuantityIncrement: this._handleQuantityIncrement.bind(this),
      }
    },

    _handleQuantityDecrement:function(){
      if( this.cache.quantity.value >1 && !this.cache.quantity.disabled){

        this.cache.quantity.value = Number(this.cache.quantity.value) - 1 ;
      }
    },

    _handleQuantityIncrement:function(){
      if( !this.cache.quantity.disabled){
        this.cache.quantity.value = Number(this.cache.quantity.value) + 1;
      }
    },
  })
   return ProductQuantitySection;
})();

var ProductQuantitySec = new window.ProductQuantitySection(document.querySelector('[data-section-type="product"]'));

/* triger the stiky effect on */
var visibilityState ={
  santinel:false,
  buyBox:false,
  footer:false,
}
var buyBoxElem = document.querySelector('[data-product-form-js-hook]')
var sentinalEl = document.querySelector('[data-santinel-trigger-product-form-js-hook]')
var footerEl = document.querySelector('footer');

var handleStikyState = function(){
  var scrollPosition = window.pageYOffset;

  if(!visibilityState.buyBox && scrollPosition > buyBoxElem.offsetTop && !visibilityState.footer){
    buyBoxElem.classList.add('product-page-fixed-buy');
    buyBoxElem.querySelector('.product-form-root-wrapper').classList.add('animate');
    buyBoxElem.querySelector('.product-form-root-wrapper').classList.add('shadow-menu');
  }else{
    buyBoxElem.classList.remove('product-page-fixed-buy');
    buyBoxElem.querySelector('.product-form-root-wrapper').classList.remove('animate');
    buyBoxElem.querySelector('.product-form-root-wrapper').classList.remove('shadow-menu');
  }

  //console.log('visibilityState',visibilityState);
}

const buyBoxObserver = new window.IntersectionObserver(function(entries){
  if (!entries[0].isIntersecting) {
    visibilityState.buyBox = false;
  } else {
    visibilityState.buyBox = true;
  }
  handleStikyState();
})
buyBoxObserver.observe(buyBoxElem)

const footerObserver = new window.IntersectionObserver(function(entries){
  if (!entries[0].isIntersecting) {
    visibilityState.footer = false;
  } else {
    visibilityState.footer = true;
  }
  handleStikyState();
})
footerObserver.observe(footerEl,{
  threshold: 0.5
})

/*Smoother scroll than JDG default*/
setTimeout(function(){
  var productSectionRoot = document.querySelector('#shopify-section-product-template-bundle-app');
  var reviewAppPreviewBadge  = productSectionRoot.querySelector('.review  .jdgm-widget');
  var cloneReviewAppPreviewBadge =  reviewAppPreviewBadge.cloneNode(true);
  cloneReviewAppPreviewBadge.querySelector('.jdgm-prev-badge').addEventListener(
    'click',
 function(){
  /*document.querySelector(".review-section-root").scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});*/
  //var reviewSectionOffset = document.querySelector(".review-section-root").getBoundingClientRect().top /*+ document.querySelector("header").offsetHeight*/;
  var reviewSectionOffsetPosition = document.querySelector(".review-section-root").offsetTop - 50 ;

  window.scrollTo({
    top: reviewSectionOffsetPosition,
    left: 0,
    behavior: 'smooth'
  });

 }
  );
  reviewAppPreviewBadge.parentNode.replaceChild(cloneReviewAppPreviewBadge, reviewAppPreviewBadge);

},500)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-info-bundle-app"]) return;
  try {
    

$("document").ready(function(){

$(".product-bundle-widget-root .js--bundle-tab").on('click',function(e){
  e.preventDefault();

  $(this).closest('.product-bundle-widget-root').find('.js--bundle-tab').addClass('border-gray-deep').removeClass('border-purple');
  $(this).addClass("border-purple").removeClass('border-gray-deep');
  
  var target = $(this).attr("data-target-tabpanel");
  $(this).closest('.product-bundle-widget-root').find('.js--bundle-tabpanel').addClass('md:hidden');
  $('.'+target).removeClass('md:hidden');

})



$(".tabs-widget-root .js--tab").on("click",function(e){
  e.preventDefault();

  $(this).closest('.tabs-widget-root').find('.js--tab').addClass('bg-white text-purple').removeClass('bg-purple text-white');
  $(this).addClass("bg-purple text-white").removeClass('bg-white text-purple');
  
  var target = $(this).attr("data-target-tabpanel");
  $(this).closest('.tabs-widget-root').find('.js--tabpanel').addClass('md:hidden');
  $('.'+target).removeClass('md:hidden');

 })

 $(".js--accordion").on("click",function(e){      
  e.preventDefault(); 
  $(this).parent().find('.content-body').toggleClass('pb-6 pt-1 h-0');
})

})   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-info"]) return;
  try {
    

$("document").ready(function(){

$(".tabs-widget-root .js--tab").on("click",function(e){
  e.preventDefault();

  $(this).closest('.tabs-widget-root').find('.js--tab').addClass('bg-white text-purple').removeClass('bg-purple text-white');
  $(this).addClass("bg-purple text-white").removeClass('bg-white text-purple');
  
  var target = $(this).attr("data-target-tabpanel");
  $(this).closest('.tabs-widget-root').find('.js--tabpanel').addClass('md:hidden');
  $('.'+target).removeClass('md:hidden');

 })

 $(".js--accordion").on("click",function(e){      
  e.preventDefault(); 
  $(this).parent().find('.content-body').toggleClass('pb-6 pt-1 h-0');
})

})   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
window.ProductQuantitySection = (function () {
  var selectors = {
    quantity: '[data-quantity-input]',
    quantityDecrement: '[data-quantity-decrement]',
    quantityIncrement: '[data-quantity-increment]'
  }

  function ProductQuantitySection(container) {

    this.container = container;
    this.cache = {};
    this.eventHandlers = {};
    this._cacheSelectors();
    this._setupListeners();
  }

  ProductQuantitySection.prototype = Object.assign({}, ProductQuantitySection.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        quantity: this.container.querySelector(
          selectors.quantity
        ),
        quantityDecrement: this.container.querySelector(
          selectors.quantityDecrement
        ),
        quantityIncrement: this.container.querySelector(
          selectors.quantityIncrement
        ),
      }
    },

    _setupListeners: function() {
      this.eventHandlers = this._setupEventHandlers();

      this.cache.quantityDecrement.addEventListener(
        'click',
         this.eventHandlers.handleQuantityDecrement
      );

      this.cache.quantityIncrement.addEventListener(
        'click',
        this.eventHandlers.handleQuantityIncrement
      );
    },

    _setupEventHandlers:function(){
      return {
        handleQuantityDecrement: this._handleQuantityDecrement.bind(this),
        handleQuantityIncrement: this._handleQuantityIncrement.bind(this),
      }
    },

    _handleQuantityDecrement:function(){
      if( this.cache.quantity.value >1 && !this.cache.quantity.disabled){

        this.cache.quantity.value = Number(this.cache.quantity.value) - 1 ;
      }
    },

    _handleQuantityIncrement:function(){
      if( !this.cache.quantity.disabled){
        this.cache.quantity.value = Number(this.cache.quantity.value) + 1;
      }
    },
  })
   return ProductQuantitySection;
})();

var ProductQuantitySec = new window.ProductQuantitySection(document.querySelector('[data-section-type="product"]'));

/* triger the stiky effect on */
var visibilityState ={
  santinel:false,
  buyBox:false,
  footer:false,
}
var buyBoxElem = document.querySelector('[data-product-form-js-hook]')
var sentinalEl = document.querySelector('[data-santinel-trigger-product-form-js-hook]')
var footerEl = document.querySelector('footer');

var handleStikyState = function(){
  var scrollPosition = window.pageYOffset;

  if(!visibilityState.buyBox && scrollPosition > buyBoxElem.offsetTop && !visibilityState.footer){
    buyBoxElem.classList.add('product-page-fixed-buy');
    buyBoxElem.querySelector('.product-form-root-wrapper').classList.add('animate');
    buyBoxElem.querySelector('.product-form-root-wrapper').classList.add('shadow-menu');
  }else{
    buyBoxElem.classList.remove('product-page-fixed-buy');
    buyBoxElem.querySelector('.product-form-root-wrapper').classList.remove('animate');
    buyBoxElem.querySelector('.product-form-root-wrapper').classList.remove('shadow-menu');
  }

  //console.log('visibilityState',visibilityState);
}

const buyBoxObserver = new window.IntersectionObserver(function(entries){
  if (!entries[0].isIntersecting) {
    visibilityState.buyBox = false;
  } else {
    visibilityState.buyBox = true;
  }
  handleStikyState();
})
buyBoxObserver.observe(buyBoxElem)

const footerObserver = new window.IntersectionObserver(function(entries){
  if (!entries[0].isIntersecting) {
    visibilityState.footer = false;
  } else {
    visibilityState.footer = true;
  }
  handleStikyState();
})
footerObserver.observe(footerEl,{
  threshold: 0.5
})

/*Smoother scroll than JDG default*/
setTimeout(function(){
  var productSectionRoot = document.querySelector('#shopify-section-product-template');
  var reviewAppPreviewBadge  = productSectionRoot.querySelector('.review  .jdgm-widget');
  var cloneReviewAppPreviewBadge =  reviewAppPreviewBadge.cloneNode(true);
  cloneReviewAppPreviewBadge.querySelector('.jdgm-prev-badge').addEventListener(
    'click',
 function(){
  /*document.querySelector(".review-section-root").scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});*/
  //var reviewSectionOffset = document.querySelector(".review-section-root").getBoundingClientRect().top /*+ document.querySelector("header").offsetHeight*/;
  var reviewSectionOffsetPosition = document.querySelector(".review-section-root").offsetTop - 50 ;

  window.scrollTo({
    top: reviewSectionOffsetPosition,
    left: 0,
    behavior: 'smooth'
  });

 }
  );
  reviewAppPreviewBadge.parentNode.replaceChild(cloneReviewAppPreviewBadge, reviewAppPreviewBadge);

},500)

/*
var el = document.getElementById('el-id'),
    elClone = el.cloneNode(true);

el.parentNode.replaceChild(elClone, el);
*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secom-gdpr"] && !Shopify.designMode) return;
  try {
    

window.dataLayer = window.dataLayer || [];
window.GdprSection = (function () {

    var selectors = {
      btnAllowAll: '[data-gdpr-btn-allow-all]',
      btnSettings: '[data-gdpr-btn-settings]',
      btnApplySettings: '[data-gdpr-btn-apply-options]',
      optionAnalytical: '[data-gdpr-checkbox-analytical]',
      optionPublicity: '[data-gdpr-checkbox-publicity]',      
      optionsForm: '[data-gdpr-form]',      
      bar: '[data-gdpr-bar]',      
      settingsModal: '[data-gdpr-modal]',           
    };

    function Gdpr(container, config,cookie_tool) {
      this.cookieTool = cookie_tool;
      this.container = container;
      this.cookieSettings = config;
      this.cache = {};
      this._cacheSelectors();
      this._setupListeners();
      this.init();
    }

    Gdpr.prototype = Object.assign({}, Gdpr.prototype, {

      _cacheSelectors: function () {
        this.cache = {
            btnAllowAll: this.container.querySelector(
            selectors.btnAllowAll
          ),
          btnSettings: this.container.querySelector(
            selectors.btnSettings
          ),
          btnApplySettings: this.container.querySelector(
            selectors.btnApplySettings
          ),
          checkboxAnalytical: this.container.querySelector(
            selectors.optionAnalytical
          ),
          checkboxPublicity: this.container.querySelector(
            selectors.optionPublicity
          ),       
          optionsForm: this.container.querySelector(
            selectors.optionsForm
          ),     
          bar: this.container.querySelector(
            selectors.bar
          ),       
          settingsModal: this.container.querySelector(
            selectors.settingsModal
          ),       
          
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.btnAllowAll.addEventListener(
          'click',
          this.eventHandlers._handleAllowAllCookies
        );

        this.cache.btnSettings.addEventListener(
          'click',
          this.eventHandlers._handleSettingsModal
        );

        this.cache.btnApplySettings.addEventListener(
          'click',
          this.eventHandlers._handleApplySettings
        );
      },

      _setupEventHandlers: function () {
        return {
          _handleAllowAllCookies: this.setAllowedAll.bind(this),
          _handleApplySettings: this.setAllowed.bind(this),
          _handleSettingsModal: this.showAdvancedSettings.bind(this),
        };
      },

      init: function () {          
        if (!this.getShown()) {
            this.showBar();
        } else {
            this.hideBar();
            this.getAllowed();
        }
    },

    showBar: function () {      
        this.cache.bar.classList.remove("hidden");
    },
    toggleBar:  function () {
  
        this.cache.bar.classList.classList.toggle("hidden");
    },
    hideBar:  function () {
    
        this.cache.bar.classList.add("hidden");
    },

    showAdvancedSettings:  function (e) {
        e.preventDefault();
      this.cache.settingsModal.classList.remove("hidden");
      this.hideBar();
    },

    hideAdvancedSettings: function () {
      this.cache.settingsModal.classList.add("hidden");
  
    },

    setAllowedAll: function (e) {
        e.preventDefault();
        var allowed = ['functional', 'analytical', 'publicity'];
        //this.pushGtmEvent(allowed);
        cookieTool.setCookie('cookiePolicy', allowed.join(","), 365);
        cookieTool.setCookie('gdpr_bar_hidden', '1', 365);
        cookieTool.setCookie('adStorageConsent', '1', 365);
        this.hideBar();        
        setTimeout(function(){
            location.reload();     
        },100)  
    },

    setAllowed: function (e) {
        e.preventDefault();

        var formElements = this.cache.optionsForm.elements;
        var allowed = [/*'functional'*/];
            for (var i = 0; i < formElements.length; i++) {
                var elementName = formElements[i].getAttribute("name");
                if (elementName && formElements[i].checked) {
                    allowed.push(elementName);
                } else if (!formElements[i].checked) {
                    cookieTool.deleteCookies(elementName, cookieTool.analyticalCookies(), cookieTool.publicityCookies(), cookieTool.functionalCookies());
                }
            }
        //this.pushGtmEvent(allowed);
        cookieTool.setCookie('cookiePolicy', allowed.join(","), 365);
        cookieTool.setCookie('gdpr_bar_hidden', '1', 365);
        cookieTool.setCookie('adStorageConsent', '1', 365);
        this.hideAdvancedSettings();   
        setTimeout(function(){
            location.reload();     
        },100)        
    },

    getAllowed: function () {
        var scopeSettings = this.cookieSettings.scopes;
        var allowed;
        var configurationSaved = cookieTool.getCookie('cookiePolicy');
        (cookieTool.getCookie('cookiePolicy')) ? allowed = cookieTool.getCookie('cookiePolicy').split(",") : allowed = [];
        var siteScripts = document.scripts;
        var scriptsToAppend = [];
        for (var i = 0; i < scopeSettings.length; i++) {
            if (scopeSettings[i].required == 1) {
                allowed.push(scopeSettings[i].scope);
                continue;
            }
            if (!configurationSaved && scopeSettings[i].preallowed == 1) {
                allowed.push(scopeSettings[i].scope);
                continue;
            }
        }
        /*trigger gtm event*/        
        //this.pushGtmEvent(allowed);
        if (allowed.indexOf('analytical') == -1) {
            cookieTool.deleteCookies('analytical', cookieTool.analyticalCookies(), cookieTool.publicityCookies(), cookieTool.functionalCookies());
        }

        if (allowed.indexOf('publicity') == -1) {
            cookieTool.deleteCookies('publicity', cookieTool.analyticalCookies(), cookieTool.publicityCookies(), cookieTool.functionalCookies());

        }

        for (var i = 0; i < siteScripts.length; i++) {
            var categoryScript = siteScripts[i].getAttribute('data-cookiecategory');
            if (categoryScript === null) {
                continue;
            }
            if (!allowed.includes(categoryScript)) {
                continue;
            }
            scriptsToAppend.push(siteScripts[i]);
        }

        this.appendScript(scriptsToAppend);
        return allowed;
    },
    getAnalyticalCookies: function () {

        var arr_analytical = new Array();

        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            arr_analytical[i] = name;
        }
        return arr_analytical;
    },
    getPublicityCookies: function () {

        var arr_publicity = new Array();

        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            arr_publicity[i] = name;
        }
        return arr_publicity;
    },

    getFunctionalCookies: function () {
        //console.log('getFunctionalCookies');
        var arr_functional = new Array();

        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            arr_functional[i] = name;
        }
        return arr_functional;
    },

      getShown: function () {
        const adStorageCookie = cookieTool.getCookie('adStorageConsent') || null;
        return ((cookieTool.getCookie('gdpr_bar_hidden') != 0 ? true : false) && adStorageCookie);
    },

    appendScript: function (scriptsToAppend) {
        //console.log('appendScript',scriptsToAppend);
        for (var i = 0; i < scriptsToAppend.length; i++) {

            var node = document.createElement("script");
            var textnode = document.createTextNode(scriptsToAppend[i].textContent);
            if (typeof scriptsToAppend[i].getAttribute('data-src') !== 'undefined' && scriptsToAppend[i].getAttribute('data-src') !== null) {
                node.src = scriptsToAppend[i].getAttribute('data-src');
            }
            node.appendChild(textnode);
            scriptsToAppend[i].remove();
            parent.document.getElementsByTagName('head')[0].appendChild(node);
        }
    }

    });

    return Gdpr;
  })();

  var cookieTool = cookie_tool();
  var gdprCompliance = new window.GdprSection(document.querySelector('#js-secom-gdpr-root'), gdprConfiguration,cookieTool);


  } catch(e) { console.error(e); }
})();
})();
